import React, { Fragment } from 'react';

import PropTypes from 'prop-types';

import { PageTitle } from 'components/PageTitle/PageTitle';
import { SubTitle } from 'components/SubTitle/SubTitle';

import './IncidentsContent.sass';

export const IncidentsContent = ({ content, reportSectionRef }) => {
  const renderContentItem = ({ title, tel, telFormatted }) => (
    <Fragment key={title}>
      <SubTitle text={title} notFramed />
      <div>
        <a href={`tel:${tel}`}>{telFormatted}</a>
      </div>
    </Fragment>
  );

  return (
    <>
      <div className="incidentsContent-wrapper">
        <iframe title="Störungsauskunft" className="incidentsContent-iframe" src={content.url} />
        {content.finePrintIFrame && <div className="incidents_text">{content.finePrintIFrame}</div>}
      </div>
      <div className="incidentsContent-info-wrapper" ref={reportSectionRef}>
        <PageTitle text={content.title} />
        <section className="incidentsContent-info">
          {content.items.map((item) => renderContentItem(item))}
        </section>
        {content.finePrint && (
          <div className="incidentsContent-info-fineprint">{content.finePrint}</div>
        )}
      </div>
    </>
  );
};

IncidentsContent.propTypes = {
  content: PropTypes.shape({
    url: PropTypes.string.isRequired,
    finePrintIFrame: PropTypes.string,
    title: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        tel: PropTypes.string.isRequired,
        telFormatted: PropTypes.string.isRequired,
      })
    ).isRequired,
    finePrint: PropTypes.string,
  }).isRequired,
  reportSectionRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any }),
  ]),
};

IncidentsContent.defaultProps = {
  reportSectionRef: null,
};
